import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { HttpService } from 'services/http.service';
import { EthicsChannelReportModel } from 'services/models/corporate/ethics-channel/ethics-channel-report.model';
import { QueryParams } from 'services/models/odata/queryParams';
import { ServiceBase } from 'services/servicebase';
import { Response } from 'services/models/response';
import { map } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';

@Injectable()
export class EthicsChannelReportService extends ServiceBase<EthicsChannelReportModel> {
  constructor(http: HttpService) {
    super('ethicschannel/report', http, environment.apiUrl);
  }

  createEntity(input: any): EthicsChannelReportModel {
    return EthicsChannelReportModel.create(input);
  }

  public createOrUpdate(report: any): Observable<any> {
    if (report.id) {
      return this.http.put(`${this.endpoint}/update`, report, true);
    }
    return this.http.post(`${this.endpoint}/create`, report, null, null, true);
  }

  public updateStatus(report: any): Observable<any> {
    return this.http.put(`${this.endpoint}/update-status`, report);
  }

  listReports(queryParams: QueryParams): Observable<Response<EthicsChannelReportModel[]>> {
    return this.http
      .get(`${this.endpoint}/list${this.createBuildQuery(queryParams)}`, null, null, null, true)
      .pipe(
        map(res => {
          const response = new Response<EthicsChannelReportModel[]>();
          response.data = res.body.map((pp: any) => {
            return EthicsChannelReportModel.create(pp) as EthicsChannelReportModel;
          });
          response.count = res.headers.get('x-count');
          return response;
        })
      );
  }

  listByLoggedEmployee(queryParams: QueryParams): Observable<Response<EthicsChannelReportModel[]>> {
    return this.http
      .get(
        `${this.endpoint}/list-by-logged-employee${this.createBuildQuery(queryParams)}`,
        null,
        null,
        null,
        true
      )
      .pipe(
        map(res => {
          const response = new Response<EthicsChannelReportModel[]>();
          response.data = res.body.map((pp: any) => {
            return EthicsChannelReportModel.create(pp) as EthicsChannelReportModel;
          });
          response.count = res.headers.get('x-count');
          return response;
        })
      );
  }

  getSummary(filters: any): Observable<any> {
    let params = new HttpParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        params = params.set(key, value as any);
      }
    });

    return this.http
      .get(`${this.endpoint}/summary`, { params }, null, null, true)
      .pipe(map((data: any) => data.body));
  }

  getWeeklyStatistics(): Observable<any> {
    return this.http
      .get(`${this.endpoint}/weekly-statistics`, null, null, null, true)
      .pipe(map((data: any) => data.body));
  }

  deleteReport(id: string): Observable<Response<any>> {
    return this.http.remove(`${this.endpoint}/${id}`).pipe(
      map(res => {
        const response = new Response<any>();
        response.data = res;
        return response;
      })
    );
  }

  exportReports(queryParams: QueryParams): Observable<ArrayBuffer> {
    return this.http
      .get(
        `${this.endpoint}/export${this.createBuildQuery(queryParams)}`,
        { responseType: 'arraybuffer' },
        this.baseUrl,
        undefined,
        true
      )
      .pipe(map((response: any) => response.body as ArrayBuffer));
  }
}
